import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M32.5 35C25.6 35 20 29.4 20 22.5S25.6 10 32.5 10 45 15.6 45 22.5 39.4 35 32.5 35zm0-22.5c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M33.7 7.4V0h-26L0 7.7V45h33.7v-7.4h-2.5v4.9H2.5V11.2h8.8V2.5h19.9v4.9h2.5zM8.8 8.7H2.5l6.2-6.2v6.2z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.4,
			y: 26.3,
			className: "icon-fill-primary",
			width: 10.5,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.4,
			y: 35.1,
			className: "icon-fill-primary",
			width: 16.1,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.4,
			y: 17.5,
			className: "icon-fill-primary",
			width: 10.5,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "30.6 28.1 26.2 23.8 28 22 30.6 24.6 37.4 17.8 39.2 19.5"
		})
	]
});
export default SvgIcon;
